import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({ value, onChange, placeholder, dataTestid, ariaShow = "Afficher le mot de passe", ariaHide = "Masquer le mot de passe", ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...rest}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="input-base pr-12"
        data-testid={dataTestid}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 px-3 grid place-items-center text-zinc-400 hover:text-white transition-colors"
        aria-label={visible ? ariaHide : ariaShow}
        data-testid={dataTestid ? `${dataTestid}-toggle` : "password-toggle"}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
